export interface PyWorkerConfig {
  pyodideVersion: string;
  pyodidePackages: string[];
  pyscriptApps: string[];
  micropipPackages: string[];
  initCode: string;
}

export enum PyEnvironmentStatus {
  NOT_STARTED = "Not Started",
  INITIALIZING = "Initializing...",
  LOADING_PYODIDE_PACKAGES = "Loading pyodide packages...",
  LOADING_MICROPIP_PACKAGES = "Loading micropip packages...",
  LOADING_PYSCRIPT_APPS = "Loading pyscript apps...",
  RUNNING_INIT_CODE = "Running imports and definitions...",
  READY = "Ready",
  ERROR = "Error",
}
